// src/client/config/clientConfig.js
import clients from './clients';

// 🔑 Récupérer le client actif
// 1. depuis localStorage (si l’admin a choisi un client en mode dev)
// 2. sinon on fallback sur "le_resto_local"
const activeClientKey =
  localStorage.getItem('selectedClient') || 'le_resto_local';

const client = clients[activeClientKey] || {};

// ✅ Configuration client dynamique
const clientConfig = {
  key: activeClientKey,
  name: client.name || 'Site Démo',
  theme: client.theme || 'theme2', // le thème est défini par clients.js
  texts: client.texts || {},
};

export default clientConfig;
